import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_6 = {
  key: 1,
  class: "container"
}
const _hoisted_7 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'

    import { useOrganizationUnitQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'
    import { useUpdateOrganizationUnitCommandV1 } from '@Organizations/OrganizationUnits/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageOrganizationPage',
  setup(__props) {

    const route = useRoute()

    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const name = ref('')
    const description = ref('')

    // ---------------- query ----------------

    const {
        modelOrganizationUnitQueryV1: organizationUnit,
        runOrganizationUnitQueryV1
    } = useOrganizationUnitQueryV1(tid)

    // ---------------- command ----------------

    const {
        invokeUpdateOrganizationUnitCommandV1,
        invokingUpdateOrganizationUnitCommandV1,
        succeedUpdateOrganizationUnitCommandV1,
        validationErrorsUpdateOrganizationUnitCommandV1
    } = useUpdateOrganizationUnitCommandV1(
        computed(() => organizationUnit.value?.Id),
        name,
        description
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Manage organization'
        runOrganizationUnitQueryV1()
    })

    // ---------------- sync read model → form ----------------

    watch(organizationUnit, (ou) =>
    {
        if (!ou) return

        name.value = ou.Name
        description.value = ou.Description
    }, { immediate: true })

    // ---------------- derived ----------------

    const organizationId = computed(() =>
        organizationUnit.value?.Id
    )

    const statusInvoking = computed(() =>
        invokingUpdateOrganizationUnitCommandV1.value
    )

    const statusSucceed = computed(() =>
        succeedUpdateOrganizationUnitCommandV1.value
    )

    const validationErrors = computed(() =>
        validationErrorsUpdateOrganizationUnitCommandV1.value
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage organization</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!statusSucceed.value && organizationId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Name of workspace"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, name.value]
            ]),
            _createVNode(ValidationError, {
              context: "Name",
              errors: validationErrors.value
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
              class: "form-control",
              placeholder: "Description of workspace"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, description.value]
            ]),
            _createVNode(ValidationError, {
              context: "Description",
              errors: validationErrors.value
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          (!statusInvoking.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(invokeUpdateOrganizationUnitCommandV1) && _unref(invokeUpdateOrganizationUnitCommandV1)(...args))),
                type: "button",
                class: "btn btn-primary btn-lg"
              }, "Save"))
            : (_openBlock(), _createElementBlock("button", _hoisted_5, "Saving..."))
        ]))
      : (statusSucceed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Congratulation! Organization was updated.", -1 /* CACHED */)),
            _createElementVNode("a", {
              class: "btn btn-primary btn-lg",
              href: `/#/admin/organizations/dashboard/${tid.value}`,
              role: "button"
            }, "Go to dashboard", 8 /* PROPS */, _hoisted_7)
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}
}

})